import { Controller } from "@hotwired/stimulus"
// Purpose:
// - Enables/Disables the PIN field based on the length of the OTP code
// - Displays a countdown until the OTP expires
// - Shows a "Resend Code" link once the OTP has expired

export default class extends Controller {
    static targets = ["otpCode", "pinCode", "countdown", "resendLink"]
    static values = { expiresAt: String, expiredText: String }

    connect() {
        this.togglePinDisabled()

        if (this.hasOtpCodeTarget) {
            // register input listner for OTP field
            this.onInput = () => this.togglePinDisabled()
            this.otpCodeTarget.addEventListener("input", this.onInput)
        }
    
        this.startCountdown()
    }

    // Clean up when controller is removed from DOM
    disconnect() {
        if (this.onInput && this.hasOtpCodeTarget) {
            this.otpCodeTarget.removeEventListener("input", this.onInput)
        }
        if (this.timer) clearInterval(this.timer)
    }

    // Enable or disable the pin field depending in OTP length
    togglePinDisabled() {
        const val = (this.otpCodeTarget?.value || "").trim()
        if (val.length >= 5) this.pinCodeTarget?.removeAttribute("disabled")
        else this.pinCodeTarget?.setAttribute("disabled", "true")
    }

    startCountdown() {
        if (!this.hasCountdownTarget || !this.hasExpiresAtValue) return
        const deadline = new Date(this.expiresAtValue).getTime()
        if (Number.isNaN(deadline)) return

        this.timer = setInterval(() => {
            const distance = deadline - Date.now()

            if (distance <= 0) {
                clearInterval(this.timer)
                this.countdownTarget.textContent = this.expiredTextValue || "Expired"
                if (this.hasResendLinkTarget) {
                    // show resend link
                    this.resendLinkTarget.classList?.remove("d-none")
                    if (this.resendLinkTarget.style?.display === "none") {
                        this.resendLinkTarget.style.display = ""
                    }
                }
                return
            }

            // calculate remaining minutes and seconds
            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
            const seconds = Math.floor((distance % (1000 * 60)) / 1000)
            this.countdownTarget.textContent = `${minutes}m ${seconds}s`
        }, 1000)
    }
}